import { Role } from './role.enum';
import { Privilege } from './privilege.interface';

/**
 * Basic information about the logged-in user
 */
export interface UserInfo {
  id: string;
  email: string;
  displayName: string;
}

/**
 * User authorization context
 * Contains roles, privileges and methods for checking access
 */
export interface UserContextState {
  /**
   * Whether user data has been loaded
   */
  isLoaded: boolean;

  /**
   * Basic user information
   */
  user: UserInfo | null;

  /**
   * User roles (from AAD groups)
   */
  roles: Role[];

  /**
   * Effective privileges (merged from all roles)
   * For the same permissionKey, the highest access level is selected
   */
  privileges: Privilege[];

  /**
   * Loading errors (if any occurred)
   */
  errors?: string[];
}

/**
 * Initial user context state
 */
export const INITIAL_USER_CONTEXT: UserContextState = {
  isLoaded: false,
  user: null,
  roles: [],
  privileges: [],
  errors: []
};
